import { GetStaticProps } from 'next'
import AccountPage from '@components/account/pages/account'
import { AuthProvider } from '@api/accounts/auth/hooks/useAuth'

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      pageEntries: [{ headerTheme: 'transparent-light' }]
    }
  }
}

const PageNext = () => (
  <AuthProvider>
    <AccountPage />
  </AuthProvider>
)

export default PageNext
